/**
 * A documentação do RPG Desk (apps/docs), publicada à parte: o português na raiz e o inglês em /en/,
 * com os mesmos caminhos. `VITE_DOCS_URL` troca o endereço (uma prévia, um servidor próprio).
 */
import type { Language } from './i18n/index.js';

export const DOCS_URL = withSlash(import.meta.env.VITE_DOCS_URL || 'https://docs.rpgdesk.com/');

/** Uma página da documentação no idioma: `path` como 'sala/dados', ou '' para o início. */
export function docsUrl(path: string, language: Language, base: string = DOCS_URL): string {
  const page = path.replace(/^\/+|\/+$/g, '');
  return `${withSlash(base)}${language === 'en' ? 'en/' : ''}${page ? `${page}/` : ''}`;
}

function withSlash(url: string): string {
  return url.endsWith('/') ? url : `${url}/`;
}
